import React from 'react'
import { Link } from 'react-router-dom'
import ThemeLogo from "components/ThemeLogo";
import { getFallbackLogo } from "utilities/getFallbackLogo";

export default function Logo() {
  return (
    <>
      <Link to="/" className="text-decoration-none">
        <div className="d-flex" tabIndex="0" role="img" aria-label="Company Logo Go to home">
          <ThemeLogo fallbackSrc={getFallbackLogo()} alt="Company logo" />
        </div>
      </Link>
    </>
  );
}
